import http from '@/utils/http';

/**
 * 区域管理
 */
export default {
  getList: {
    p: 'post,/manage/area/getlist',
    r: (data) => http({ url: '/manage/area/getlist', method: 'post', data })
  },
  add: {
    p: 'post,/manage/area/add',
    r: (data) => http({ url: '/manage/area/add', method: 'post', data })
  },
  update: {
    p: 'post,/manage/area/update',
    r: (data) => http({ url: '/manage/area/update', method: 'post', data })
  },
  del: {
    p: 'post,/manage/area/delete',
    r: (data) => http({ url: '/manage/area/delete', method: 'post', data })
  },
  getOne: {
    p: 'post,/manage/area/getOne',
    r: (data) => http({ url: '/manage/area/getOne', method: 'post', data })
  },
  getAllArea: { 
    p: 'post,/general/get_area_tree',
    r: (data) => http({ url: '/general/get_area_tree', method: 'post', data })
  },
  exportFile: {
    p: 'post,/system/export/user',
    r: (data) => http({ url: '/system/export/user', method: 'post', responseType: 'blob', data })
  }
};
